import { API } from "@aws-amplify/api";
import { API_NAME } from "../constants";

function ActiveToken(centerId) {
  let path = "/activetoken/" + centerId;
  return API.get(API_NAME, path);
}

export default ActiveToken;
